// extracted by mini-css-extract-plugin
export default {"head":"VehicleInfo_head__9hl-T","home_live_metrics":"VehicleInfo_home_live_metrics__P5fBF","info":"VehicleInfo_info__Pz3gW"};